// extracted by mini-css-extract-plugin
export default {"titleL":"index_titleL_AK9yz"};